import { createStore } from 'owa-satcheljs';

export type MyOutlookTab = 'foryou' | 'mirror' | 'profile';

export interface MyOutlookViewState {
    isFullPageShowing: boolean;
    initialTab: MyOutlookTab;
    isSectionHidden: boolean;
}

const getMyOutlookViewState: () => MyOutlookViewState = createStore<MyOutlookViewState>(
    'MyOutlookViewState',
    {
        isFullPageShowing: false,
        initialTab: 'foryou' as MyOutlookTab,
        isSectionHidden: false,
    }
);

export default getMyOutlookViewState;
